import inOffsetRectBounds from "./inOffsetRectBounds";
import { useState, useEffect, useRef } from 'react';

import useMutationObserver from './useMutationObserver';
import TutorialBoundingBox from './TutorialBoundingBox';
import A from './ActionCreators';
import { useDispatch, useStore } from 'react-redux';
import TutorialIntro from './TutorialIntro';
import TutorialMessage from './TutorialMessage';
import walkthrough from './WalkthroughOrder';
import TutorialNav from './TutorialNav';
import ConfirmExitTutorial from './ConfirmExitTutorial';
import { useSelector } from 'react-redux';
import computeErrorPopupPosition from './computeErrorPopupPosition';


(function() {
  const originalPreventDefault = Event.prototype.preventDefault;

  Event.prototype.preventDefault = function(...args) {
    if( this.type?.includes("mouse")){
    console.log("preventDefault called on:", this.type, this); 
    console.log(new Error());
    // do whatever tracking you want here
      }
    return originalPreventDefault.apply(this, args);
  };
})();

(function() {
  const origStop = Event.prototype.stopPropagation;
  Event.prototype.stopPropagation = function() {
    if( this.type && this.type.includes('mouse') ){
      console.warn('stopPropagation called on', this.type, 'event:', this);
      console.trace();
    }
    return origStop.apply(this, arguments);
  };
})();



/*const setTutorialStateIndex = (dispatch,index,walkthrough) => {
  
}*/


export default function Tutorial({children}){

  let store = useStore();
  let state = store.getState();
  let dispatch = useDispatch();

  const [ shouldCapture, setShouldCapture ] = useState(true);



  const [ refreshFlag, setRefreshFlag ] = useState(false);

  const [ tutorialStateIndex, setTutorialStateIndex ] = useState(0);

  let requiredMode = walkthrough[tutorialStateIndex]?.mode 
  let currentMode = state.ui.mode;
  if( requiredMode && currentMode !== requiredMode ){
    dispatch(A.setUiMode({mode:requiredMode}));
  }





  

  /*
  useEffect(() => {

    dispatch(A.setTutorialState({ index:tutorialStateIndex, title:walkthrough[tutorialStateIndex].title }));

  },[tutorialStateIndex])
  */

  /*let { tutorialStateIndex, tutorialStateTitle } = useSelector(state => { return { 
    tutorialStateIndex:state.tutorialState.index,
    tutorialStateTitle:state.tutorialState.title,
  }});*/

  /*
  if( tutorialStateIndex === undefined ){
    if( !tutorialStateTitle ){
      tutorialStateIndex = 0;
    }else{
      tutorialStateIndex = walkthrough.findIndex(stage => stage.title === tutorialStateTitle);
    }
  }*/




  
  
  
  
  
  let confirmExit = state.confirmExitTutorial === true;




  let tutorialState = walkthrough[tutorialStateIndex];


  if( tutorialState.title === 'LABEL_HEK293'
  || tutorialState.title === 'LABEL_HELA' ||
  tutorialState.selector === 'textarea[name=cellValueInput]'){

    //HACK TO MAKE SURE WE STAY FOCUSED
    //ON INPUT IN THESE STAGES
    let sel = tutorialState.selector;
    let el = document.querySelector(sel);
    el.focus();

  }



  let { selector } = tutorialState || {};

  const [ functionsToApplyOnRerender, setFunctionsToApplyOnRerender ] = useState([]);
  
  const [draggingMouse, setDraggingMouse] = useState(false);
  const [ errorPopup, _setErrorPopup ] = useState();
  const [ gotoNextStateOnClick, setGotoNextStateOnClick ] = useState(false);
  const [ gotoNextStateOnKeyUp, setGotoNextStateOnKeyUp ] = useState(false);

  const [ gotoNextStateOnRerender, setGotoNextStateOnRerender ] = useState(false);
  let [ guideOutline, setGuideOutline ] = useState();

  const setErrorPopup = (data,e) => {

    

    if( ! data ){
      _setErrorPopup(data);
      return;
    }


    let errorPopupPosition = data;
    if( guideOutline ){
      errorPopupPosition = computeErrorPopupPosition({position:data.position,guideOutline,tutorialState});
    }    


    _setErrorPopup({
      ...data,
      ...errorPopupPosition,
      tutorialState:tutorialState.title,
    });
  }

  
  const changeState = direction => {
    let nextStateIndex = tutorialStateIndex + direction;
    let nextStage = walkthrough[nextStateIndex];
    let { onEnterViaNav } = nextStage || {};

    setGotoNextStateOnClick(false);
    setGotoNextStateOnKeyUp(false);
    setGuideOutline(null);
    setErrorPopup(null);
    setTutorialStateIndex(nextStateIndex)//dispatch,nextStateIndex,walkthrough);
    
    if( !onEnterViaNav ){
    }else{
      onEnterViaNav(dispatch);
    }
    
  }

  let nextStateOnKeyUp = () => {
    setGotoNextStateOnKeyUp(true);
  }

  const nextStateOnRerender = () => {
    //setGotoNextStateOnKeyUp(true);
    setGotoNextStateOnRerender(true)
  }
  const nextState = () => { 
    if( tutorialState.beforeStateChange ){
      tutorialState.beforeStateChange(store);
    }
    changeState(1) 
  }
  window.__nextState = nextState;


  const prevState = () => { changeState(-1) }
  window.__prevState = prevState;

  useEffect(() => {
    if( gotoNextStateOnRerender ){
      setGotoNextStateOnRerender(false);
      nextState();
    }

    if( functionsToApplyOnRerender.length > 0 ){
      functionsToApplyOnRerender.forEach(fun => fun());
      setFunctionsToApplyOnRerender([]);
    }


  })



  const bodyRef = useRef(document.body);

  const draggingMouseRef = useRef(false);
  const wasMakingProgressBeforeMouseUpRef = useRef(false);

  
  let [ selectorElement, setSelectorElement ] = useState(null);

  

  const callback = (mutationList,observer) => {
    if( !guideOutline ){
      let reqElement = document.querySelector(selector);
      if( reqElement ){


        let elementBounds = reqElement.getBoundingClientRect();
        if( elementBounds.height === 0 ){
          return;
        }

        let guideBounds = {
          width:elementBounds.width,
          height:elementBounds.height,
          top:elementBounds.top,
          left:elementBounds.left,
        }

        setSelectorElement(reqElement);
        setGuideOutline(guideBounds);
      }else{

              }
    }
  }

  useMutationObserver(bodyRef, callback);

  

  const DRAW_LINE_STAGES = [
    'DRAW_BAND',
    'DRAW_BAND_1',
    'ADJUST_CROP_1',
    'ADJUST_CROP_2',
    'CREATE_MW_0',
    'RESIZE_CROP',
    //'MOVE_MW_CONTAINER',
  ]

  

  let isDragStep = tutorialState.lineStartRequirements && tutorialState.lineEndRequirements;


  function captureEvent(event){

    if( event.type.includes("mouse")){
      //debugger;
      console.log("TARGET", event.target);
      console.log("EVENT TYPE:",event.type);
      // if( event.nativeEvent.type == 'click' ){ debugger; }


    }





    if( !tutorialState ){
      return;
    }

      

    let e = event.nativeEvent;



    if( e.key === 'Tab' ){
      e.preventDefault();
      e.stopPropagation();
      return;
    }


    if( !shouldCapture ){
      return;
    }



  
    if( e.type === 'mousedown' && e.button === 0){

      
      window.__mouseDown = true;
      window.lastMouseDownEvent = e;
      e.tutorialStateTitle = tutorialState.title;
    }
    if( e.type === 'mouseup' && e.button === 0){//  || e.type === 'keyup' ){
      window.__mouseDown = false;
      window.__downInCorrectDragRect = false;


      let startDiv = document.querySelector('[endpoint=start]');
      if( startDiv ){
        startDiv.style.opacity = 1;//'3px solid red';
      }

      let lastMouseDownEvent = window.lastMouseDownEvent;


      if( lastMouseDownEvent && tutorialState.title !== lastMouseDownEvent.tutorialStateTitle ){
        //then we want to just ignore this event...
      

        e.preventDefault();
        e.stopPropagation();
        return;
      }
    }
    



    let tutorialNav = document.querySelector("#tutorial-nav")
    let exitTutorial = document.querySelector('#exit-tutorial');

    let allowClick = e.composedPath().find(pathElement => {
      return (
        pathElement === tutorialNav 
        || 
        pathElement === exitTutorial
      )
    })

    if( allowClick ){
      return;
    }

    if( e.type === 'click' && gotoNextStateOnClick ){
      nextState();
    }

    if( e.type === 'keyup' && gotoNextStateOnKeyUp ){
      nextState()
    }else{
    }

    if( isDragStep || DRAW_LINE_STAGES.includes(tutorialState.title) ){



      captureDrawBandEvent({e,tutorialState,guideOutline,setErrorPopup,draggingMouseRef, selectorElement, nextState, 
        nextStateOnClick:() => setGotoNextStateOnClick(true),
        addFunctionToApplyOnRerender:(fun) => setFunctionsToApplyOnRerender([...functionsToApplyOnRerender,fun]),
        nextStateOnRerender:() => setGotoNextStateOnRerender(true),
        setRefreshFlag,
        refreshFlag,
      });
      return;
    }


    let { ignoreEventTypes, onEvent } = tutorialState
    if( ignoreEventTypes && ignoreEventTypes.includes(e.type) ){
      //if it's not a mouse click, allow everything to do what it needs to do?
      return;
    }

    if( onEvent ){
      onEvent({e,setErrorPopup,nextStateOnRerender,selector,nextStateOnKeyUp});
    }


    const defaultCapturedMouseEventTypes = ['click','contextmenu',
      'mousedown','mouseup'
    ]

    if( tutorialState.captureAllMouseEvents ){
      defaultCapturedMouseEventTypes.push(...[
        'mousedown','mouseup'
      ])
    }
    const isMouseEventCaptured = defaultCapturedMouseEventTypes.includes(e.type);

    if( e.composedPath && isMouseEventCaptured ){


      let element = e.target;
      
      let requiredSelector = selector; 
      

      console.log(element,requiredSelector);
      let path = e.composedPath();


      let elementMatches = element.matches(requiredSelector) || path.some(el => el?.matches?.(selector));

      if( !elementMatches ){

        e.preventDefault();
        e.stopPropagation();
        console.log("We're ducking out.");
        return;

      }else if( tutorialState.nextStateOnSelectorClick /*&& e.type === 'click'*/ ){
        console.log("Got type:",e.type);
        if(  e.type !== 'click' ){ //e.type === 'mousedown' || e.type === 'mouseup' ){


          /* commented out Aug 11, 2:15 AM : 2025
          e.preventDefault();
          e.stopPropagation();
          */
          return;
        }

        let requiredModifiers = tutorialState.requiredModifierKeys || [];

        console.log("REQUIRED MODIFIERS",requiredModifiers);

        let modifierToEnglish = {
          shiftKey:'Shift',
        }

        let missingModifiers = requiredModifiers.filter(key => {
          return !e[key]
        })

        console.log("MISSING MODIFIERS",missingModifiers);

        let haveMissingModifiers = missingModifiers.length > 0;
        if( haveMissingModifiers ){

          e.preventDefault();
          e.stopPropagation();
          
        }else{
          //setGotoNextStateOnRerender(true);
          //nextStateOnRerender();
          nextState();
        }


        
      }else if( tutorialState.nextStateOnSelectorMouseUp /*&& e.type === 'click'*/ ){
        console.log("NEXT STATE ON SELECTOR MOUSE UP!");
        console.log("Got type:",e.type);
        if(  e.type !== 'mouseup' ){ //e.type === 'mousedown' || e.type === 'mouseup' ){


          /* commented out Aug 11, 2:15 AM : 2025
          e.preventDefault();
          e.stopPropagation();
          */
          return;
        }

        let requiredModifiers = tutorialState.requiredModifierKeys || [];

        console.log("REQUIRED MODIFIERS",requiredModifiers);

        let modifierToEnglish = {
          shiftKey:'Shift',
        }

        let missingModifiers = requiredModifiers.filter(key => {
          return !e[key]
        })

        console.log("MISSING MODIFIERS",missingModifiers);

        let haveMissingModifiers = missingModifiers.length > 0;
        if( haveMissingModifiers ){

          e.preventDefault();
          e.stopPropagation();
          
        }else{
          //setGotoNextStateOnRerender(true);
          //nextStateOnRerender();
          nextState();
        }


        
      }


      else if( tutorialState.nextStateOnSelectorContextMenu ){

        debugger;
        if( e.type !== 'contextmenu' ){
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        debugger;
        nextState();
      }
    }else{

      //console.log("we tried to stop this event!");


      if( tutorialState.nextStateOnSelectorContextMenu
        ||
        tutorialState.nextStateOnSelectorClick
      ){
        event.preventDefault();
        event.stopPropagation();

          e.preventDefault()
          e.stopPropagation();
        }
    }

  }

  function handleRender(){
    let element = document.querySelector(selector);

    if( !element ){
      setGuideOutline(null);
      setSelectorElement(null);
      setTimeout(()=> {
        setRefreshFlag(!refreshFlag)
      },500);
      return;
    }

    let elementBounds = element && element.getBoundingClientRect();

    let guideBounds = {
      width:elementBounds.width,
      height:elementBounds.height,
      top:elementBounds.top,
      left:elementBounds.left,
    }
    if( !guideOutline || (JSON.stringify(guideOutline) !== JSON.stringify(guideBounds)) ){



      setGuideOutline(guideBounds);
      setSelectorElement(element);

    }

    let interval = setInterval(() => {

      let qEl = document.querySelector(selector);
      let qElBounds = qEl && qEl.getBoundingClientRect();
      if( !qElBounds ){
        clearInterval(interval);
        return;
      }
      

      let qGuideBounds = {
        width:qElBounds.width,
        height:qElBounds.height,
        top:qElBounds.top,
        left:qElBounds.left,
      }

      if( window.__maxTutorialInterval===undefined){
        window.__maxTutorialInterval = interval;
      }else if( interval > window.__maxTutorialInterval ){
        window.__maxTutorialInterval = interval;
      }else if( interval < window.__maxTutorialInterval ){
        clearInterval(interval);
      }


      

      let boundsChanged = JSON.stringify(guideOutline) !== JSON.stringify(qGuideBounds);
      if( boundsChanged ){
        setGuideOutline(qGuideBounds);
      }else{

      }


    },100)

    return () => {
      clearInterval(interval);
    }



  }

  const [ refresh, setRefresh ] = useState(false);

  useEffect(handleRender,[tutorialStateIndex,guideOutline]);

  useEffect(() => {
    window.addEventListener('resize',handleRender);
    return () => window.removeEventListener('resize',handleRender);
  })


  let guideElements = <TutorialBoundingBox {...{
    overlayStyle:walkthrough[tutorialStateIndex].overlayStyle,
    draggingMouseRef,
    guideOutline,
    tutorialState, 
    isDrawLineEvent:(isDragStep || DRAW_LINE_STAGES.includes(tutorialState.title)),
    errorPopup,
    tutorialStateIndex,
    totalSteps:walkthrough.length

  }}/>;


  let selectorHole;
  if( guideOutline ){
    selectorHole = `M 0 0 h 10000 v 10000 h -10000 v -10000 z`;
    selectorHole += ` M ${guideOutline.left} ${guideOutline.top} v ${guideOutline.height} h ${guideOutline.width} v -${guideOutline.height} h -${guideOutline.width} z`
  }

  let errorPopupHole = '';
  if( errorPopup ){
    errorPopupHole = `M ${errorPopup.position[0]} ${errorPopup.position[1]} v 75 h 300 v -75 h -300 z`

  }

  let svgPath = selectorHole + ' ' + errorPopupHole;


  if( tutorialState.scene ){

    if( tutorialState.title === 'TUTORIAL_OUTRO' ){
      let guideLayer = document.querySelector(
        '#tutorial-guideline-wrapper'
      );


      if( guideLayer ){
        guideLayer.parentNode.removeChild(
          guideLayer
        )
      }

    }



    return tutorialState.scene(()=>changeState(1));
  }


  if( confirmExit ){
    return <ConfirmExitTutorial/>
  }


  let tutorialNav;
  if( process.env.NODE_ENV !== 'production' ){
    tutorialNav = <TutorialNav {...{
        shouldCapture,
        setShouldCapture,
        tutorialState,
        tutorialStateIndex,
      setTutorialStateIndex,//:(index) => setTutorialStateIndex(dispatch,index,walkthrough),
        setRefresh,
        refresh,
        prevState,
        nextState,
        walkthrough,
        guideOutline,
      }}/>
  }

  


  return (
    <div 
      layer={"tutorial"}
      stage={tutorialState.title}
      onChangeCapture={captureEvent}
      onMouseUpCapture={captureEvent}
      onMouseDownCapture={captureEvent}
      onClickCapture={captureEvent}
      onKeyUpCapture={captureEvent}
      onKeyPressCapture={captureEvent}
      onKeyDownCapture={captureEvent}
      onContextMenuCapture={captureEvent}

      style={{
        top:0,
        left:0,
        width:'100%',
        height:'100%',
        position:'absolute',
        zIndex:0,
        //pointerEvents:'none',
      }}>
      {guideElements}
      {tutorialNav}
      {children}
      <svg key={tutorialStateIndex} style={{
        zIndex:20000,
        pointerEvents:'none',
        position:'fixed',
        top:0,
        left:0,
        width:10000,
        height:10000,
      }}>

        <path 
          style={{
            webkitBackdropFilter:'blur(10px)',
          }}
          filter="url(#tutorial-blur-filter)"
          d={svgPath} fill="black" opacity={0.3}>
                  </path>
      </svg>

      {true && errorPopup && <TutorialMessage {...{errorPopup}}/>}

    </div>
  );
}


function captureDrawBandEvent({e,tutorialState, guideOutline, setErrorPopup, draggingMouseRef, selectorElement, nextState, nextStateOnClick, 
  addFunctionToApplyOnRerender, setRefreshFlag, refreshFlag,
  nextStateOnRerender,
}){

 

  //let isMouseMove = e.type === 'mousemove';

  let { lineStartRequirements, lineEndRequirements } = tutorialState;


  

  //let requiredRect = guideOutline;

  let type = e.type;
  let isMouseDown = type === 'mousedown';
  let isMouseUp = type === 'mouseup';
  let isClick = type === 'click';

 

  if( (isClick && draggingMouseRef.current === false) || (e.button !== 0) ){
    e.preventDefault();
    e.stopPropagation();
    return;
  }



  let requiredRect;
  let endpoint;

  if( isMouseDown ){
    requiredRect = lineStartRequirements;
    endpoint = 'start';
  }else if( isMouseUp ){
    requiredRect = lineEndRequirements;
    endpoint = 'end';
  }



  let inBoundsRequiredRect = requiredRect && inOffsetRectBounds(e,guideOutline,requiredRect,endpoint);



  if( isClick && e.composedPath().includes( selectorElement ) ){
    /*if( !draggingMouseRef.current ){
      e.stopPropagation();
      e.preventDefault();
    }*/
    return;
  }


  let validClickPath = true;
  if( isMouseUp && tutorialState.isValidClickPath ){
    validClickPath = tutorialState.isValidClickPath(
      window.lastMouseDownEvent, e
    )
  }
  let inBoundsAndValidClickPath = inBoundsRequiredRect && validClickPath;


  if( inBoundsAndValidClickPath ){

    if( isMouseDown ){
      draggingMouseRef.current = true;
     
      //remove the line direction animation
      

      if( lineStartRequirements.removeWhenMouseDown ){
        let startRect = document.querySelector('[endpoint=start]');
        if( startRect ){
          startRect.style.opacity = 0;//'3px solid lime';
        }
      }

      if( lineStartRequirements.removeArrowWhenMouseDown ){

        let lineDirectionAnimation = document.querySelector('#connecting-line-svg');
        if( lineDirectionAnimation ){
          lineDirectionAnimation.parentNode.removeChild(lineDirectionAnimation);
        }
      }


    }else if( isMouseUp && draggingMouseRef.current === true ){
      // this is needed here 
      // because if you rely on mouseup,
      // there is a click event that comes directly
      // after. But the state has already changed
      // and so we get a "click" error here.
      // So, we need to wait for the 'click' event 
      // to transition so we don't get the click error.
      console.log("DOING NEXT STATE ON RERENDER!");
      //nextStateOnClick();
      //nextStateOnRerender();
      setRefreshFlag(!refreshFlag);
      nextState();
      //nextState();
    }



  }else{
    if( draggingMouseRef.current && isClick ){
      return;
    }
    if( isMouseUp && draggingMouseRef.current ){


      console.log("we ended up here!");

      

      window.dispatchEvent(new KeyboardEvent('keydown', {'key': 'Escape'}));


      draggingMouseRef.current = false;

      setErrorPopup({
        position:[e.clientX,e.clientY],
        text:(tutorialState.errorMessage || (<div><b>Click and drag</b> from <b>inside</b> the red boxes where the arrow starts to <b>inside</b> where the arrow ends.</div>))
      })
    }else{

      setErrorPopup({
        position:[e.clientX,e.clientY],
        text:(tutorialState.errorMessage || 

          (<div><b>Click and drag</b> from the <span style={{color:"red", fontWeight:'bold'}}>red box</span> where the arrow starts to where the arrow ends.</div>)
        ),
      })
    }





    if( tutorialState.onFail ){
      console.log("calling ONFAIL");
      tutorialState.onFail(e);
    }
    if( tutorialState.applyOnRerenderUponFail ){
      console.log("applyOnRerenderUponFail");
      addFunctionToApplyOnRerender(
        tutorialState.applyOnRerenderUponFail
      )
      setRefreshFlag(!refreshFlag);
    }


    if( !tutorialState.noStopPropagation ){
      console.log("Stopped propagation.");
      e.stopPropagation();
    }
    if( !tutorialState.noPreventDefault ){
      e.preventDefault();
      console.log("Prevented default.");
    }
  }

  if( isMouseUp ){
    draggingMouseRef.current = (false);
  }

}




